export default "__VITE_ASSET__CsiVbhiv__"